import { User } from "../../Models/User";
import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import PaginatedTable from "../Common/PaginatedTable";
import { Link } from "react-router-dom";
import { HiUser, HiXCircle } from "react-icons/hi";
export default function UserListTable({
  data,
  deleteUser,
}: {
  data: User[];
  deleteUser: (id: number) => void;
}) {
  const columnHelper = createColumnHelper<User>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: "id",
      header: "",
      cell: (info) => (
        <div className="flex justify-center gap-1">
          <Link to={`/user/${info.getValue()}`} className="buttonMain p-2">
            <HiUser></HiUser>
          </Link>
          <button
            type="button"
            className="buttonCancel p-2"
            onClick={() => deleteUser(info.getValue())}
            title="Delete User"
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.firstName, {
      id: "firstName",
      header: "First Name",
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
      filterFn: "includesString",
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: "lastName",
      header: "Last Name",
      sortingFn: "alphanumeric",
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.emailAddress, {
      id: "emailAddress",
      header: "Email",
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: "alphanumeric",
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.phoneNumber, {
      id: "phoneNumber",
      header: "Phone",
      cell: (info) =>
        info.row.original.phoneNumber
          ? "(" +
            info
              .getValue()
              ?.replace(/[^0-9]+/g, "")
              .slice(0, 3) +
            ") " +
            info
              .getValue()
              ?.replace(/[^0-9]+/g, "")
              .slice(3, 6) +
            "-" +
            info
              .getValue()
              ?.replace(/[^0-9]+/g, "")
              .slice(6)
          : "",
      footer: (info) => info.column.id,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: "lastName",
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className="w-full mx-auto overflow-x-auto">
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode="onChange"
          showFilters={true}
        />
      </div>
    </>
  );
}
